module.exports = __webpack_public_path__ + "img/globo.869624d8.svg";